export default __webpack_public_path__ + "img/92b5bdb83439bac0808ede2f2f49db53.svg";